<template>
    <div class="card" style="min-height: calc(100vh - 180px)">
        <div class="bg-blue-light p-1">
            <TitleButton
                btnTitle="Add New"
                :showBtn="false"
                :showAddNew="true"
                title="Pharmacy Invoice list"
                @onClickAddNewButton="navigateToAddPage"
            />
        </div>

        <div class="my-2 px-2">
            <DateQuerySetter
                btnTitle="Go"
                @onClickGo="onClickGo"
            >

                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                    <label for="colFormLabel" class="col-form-label">Patient: </label>
                    <AsyncSelect
                        placeholder="Patient Name, ID, Mobile No"
                        v-model="patient"
                        :api-service="fetchContactProfiles"
                        :additional-query="additionalQuery"
                        :format-label="formatPatientLabel"
                    />
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                    <label for="colFormLabel" class="col-form-label">Referrer: </label>
                    <AsyncSelect
                        placeholder="Select Referrer"
                        v-model="referrer"
                        :api-service="fetchContactProfiles"
                        :additional-query="{ type: 'agent' }"
                    />
                </div>

                <div class="col-12 col-sm-5 col-md-5 col-lg-3">
                    <label for="colFormLabel" class="col-form-label">Patient ID</label>
                    <vField
                        v-model="serialNo"
                        name="serial"
                        type="number"
                        class="form-control"
                        placeholder="Patient ID"
                        @keyup="onClickGo"
                    />
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                    <label for="bill-number" class="col-form-label">Bill Number: </label>
                    <input
                      id="bill-number"
                      class="form-control"
                      v-model="billNumber"
                      placeholder="Search by bill number"
                    />
                </div>
            </DateQuerySetter>
        </div>
        <div class="col-12 px-2 mt-2">
            <PharmacyListTable :purchase="purchaseList" route_name="sales-invoice-edit"/>
        </div>
        <div class="px-2"><Pagination :offset="offset" @onPageChange="onPageChange" ref="pagination"/></div>
    </div>
</template>

<script setup>
import DateQuerySetter from '@/components/atom/DateQuerySetter'
import { ref, inject, onMounted, computed  } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import handlePurchase from '@/services/modules/purchase'
import TitleButton from '@/components/atom/TitleButton'
import Pagination from '@/components/atom/Pagination'
import handleContact from "@/services/modules/contact";
import PharmacyListTable from "@/components/molecule/company/hospital/billing/pharmacy/ListTable.vue";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";

const router = useRouter()
const store = useStore()
let offset = ref(20)
let purchaseList = ref([])
const patient = ref(null)
const serialNo = ref(null)
const billNumber = ref('')
const route = useRoute()
const showError =  inject('showError');
const showSuccess =  inject('showSuccess');
const referrer = ref(null);

const {fetchSalesList} = handlePurchase()
const {fetchContactProfiles} = handleContact();
const {formatPatientLabel} = useAsyncDropdownHelper()

const additionalQuery = {
    type: "patient"
}

const companyId = computed(() => {
    return route.params.companyId
})
const startDate = computed(() => {
    return route.query.start
})
const endDate = computed(() => {
    return route.query.end
})
const page = computed(() => {
    return route.query.page
})

function navigateToAddPage() {
    router.push({name: 'pharmacy-bill-pos', params: route.params, query:route.query})
}

function getQuery () {
    let query = '?company_id=' + companyId.value
    query += '&sale_type=pharmacy_invoice'
    query += '&is_belong_to_user=1'
    if(!!patient.value) query += '&contact_profile_id=' + patient.value.id
    if(!!referrer.value) query += '&referrer_id=' + referrer.value.id;
    if(!startDate.value && !endDate.value) return query
    if(!!billNumber.value) query += '&bill_number=' + billNumber.value
    if(startDate.value) query += '&start_date='+startDate.value
    if(endDate.value) query += '&end_date='+endDate.value
    if(page.value) query += '&page='+page.value
    if(serialNo.value) query += '&serial_no=' + serialNo.value
    query += '&offset='+offset.value
    return query
}

function onClickGo() {
    fetchSalesList(getQuery())
        .then(res => {
            if(res.status) {
                purchaseList.value = res.date.data
                setPagination(res.date)
            }else {
                purchaseList.value = []
                store.commit("resetPagination")
            }

        })
}

function setPagination(data) {
    if(!data.data.length) return
    store.commit('setPaginationData', {
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

function onPageChange(page) {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    router.push({path: route.path, query: routeQuery})
    setTimeout(() => {
        onClickGo()
    },100)
}

onMounted(() => {
    onClickGo()
})

</script>
